import type { NodeDefinition } from "../domain/types/index.js";

type NodeSpec = Omit<NodeDefinition, "id"> & { id?: never };

function node(id: NodeDefinition["id"], spec: NodeSpec): NodeDefinition {
  return { id, ...spec };
}

function caseNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "case", caseId: id, next, x, y });
}

function restNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "rest", next, x, y });
}

function eventNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "event", next, x, y });
}

function relicNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "relic", next, x, y });
}

// 第11期。初手は共有の1件で、その先の3道に別れる。大規模は左右と終盤に散らし、
// レリックは中盤とボス手前に置く。入次数は2まで、交差なし。
export const MAP_NODES_EXPANSION: Record<string, NodeDefinition> = {
  start: node("start", { kind: "start", next: ["x1"], x: 3, y: 0 }),
  x1: caseNode("x1", ["x2l", "x2m", "x2r"], 3, 1),
  x2l: caseNode("x2l", ["x3a", "rest3b"], 1, 2),
  x2m: caseNode("x2m", ["x3c"], 3, 2),
  x2r: caseNode("x2r", ["e3d"], 5, 2),
  x3a: caseNode("x3a", ["x4a"], 0, 3),
  "rest3b": restNode("rest3b", ["x4b"], 2, 3),
  x3c: eventNode("x3c", ["x4b", "x4c"], 3, 3),
  e3d: eventNode("e3d", ["x4d"], 6, 3),
  x4a: caseNode("x4a", ["x5a"], 0, 4),
  x4b: caseNode("x4b", ["x5b", "relic5c"], 2, 4),
  x4c: caseNode("x4c", ["x5d"], 4, 4),
  x4d: caseNode("x4d", ["x5d", "rest5e"], 6, 4),
  x5a: caseNode("x5a", ["x6a"], 0, 5),
  x5b: caseNode("x5b", ["x6a", "x6b"], 1, 5),
  "relic5c": relicNode("relic5c", ["x6b"], 3, 5),
  x5d: caseNode("x5d", ["x6c"], 5, 5),
  "rest5e": restNode("rest5e", ["x6c"], 6, 5),
  x6a: caseNode("x6a", ["x7a"], 0, 6),
  x6b: caseNode("x6b", ["x7a", "x7b"], 2, 6),
  x6c: caseNode("x6c", ["x7b", "e7c"], 5, 6),
  x7a: caseNode("x7a", ["x8a"], 1, 7),
  x7b: caseNode("x7b", ["x8a", "x8b"], 3, 7),
  e7c: eventNode("e7c", ["x8b"], 5, 7),
  x8a: caseNode("x8a", ["rest9"], 2, 8),
  x8b: caseNode("x8b", ["rest9", "relic9r"], 4, 8),
  "rest9": restNode("rest9", ["boss"], 2, 9),
  "relic9r": relicNode("relic9r", ["boss"], 5, 9),
  boss: node("boss", { kind: "case", caseId: "expansion-boss", next: [], x: 3, y: 10 }),
};
